export default __webpack_public_path__ + "static/decent-rally-796276e4805143bd401eb303101f87df.png";